import { MessageChannel } from "@prisma/client";
import { UCookie } from "@/app/utils/UCookie";
import { CookieKey, WORKSPACE_COOKIE_MAX_AGE } from "@/app/vars/Storage";

export class UMessageChannel {
  public static readonly DEFAULT = MessageChannel.LINKEDIN;

  public static parse(raw?: string | null): MessageChannel {
    return raw && Object.values(MessageChannel).includes(raw as MessageChannel)
      ? (raw as MessageChannel)
      : UMessageChannel.DEFAULT;
  }

  public static readStored(): MessageChannel {
    return UMessageChannel.parse(UCookie.read(CookieKey.MESSAGES_CONTENT_SELECTED_CHANNEL));
  }

  public static store(channel: MessageChannel): void {
    UCookie.write(CookieKey.MESSAGES_CONTENT_SELECTED_CHANNEL, channel, WORKSPACE_COOKIE_MAX_AGE);
  }
}
